import { HTTPURL } from "../constants/Matcher";

const base = `${HTTPURL}api`;

const toQs = (params) => {
  const clean = Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  return new URLSearchParams(clean).toString();
};

export async function enquiries(params = {}) {
  const qs = toQs(params);
  try {
    const res = await fetch(`${base}/enquiries${qs ? `?${qs}` : ""}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message, data: [] };
  }
}

export async function enquiry(id) {
  try {
    const res = await fetch(`${base}/enquiry?id=${id}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message };
  }
}
